/**
 * 组件名称
 * @module filter
 * @desc 过滤器
 * @author laikt
 * @date 2018年11月2日
 * @example {1541126483|formatDate}
 **/
import Vue from "vue";
import moment from "moment";

Vue.filter("formatDate", (value, formatString) => {
    // 年月日
    if (value && value != "null") {
        formatString = formatString || "YYYY-MM-DD";
        return moment(value).format(formatString);
    }
    return "";
});
Vue.filter("formatDatetext", (value, formatString) => {
    // 年月日
    if (value && value != "null") {
        formatString = formatString || "YYYY年MM月DD日";
        return moment(value).format(formatString);
    }
    return "";
});
//时间戳转换年月日时分秒
Vue.filter("formatDateMin", (value, formatString) => {
    // 年月日
    if (value && value != "null") {
        formatString = formatString || "YYYY-MM-DD HH:mm";
        return moment(value).format(formatString);
    }
});
//时间戳转换月日时分秒
Vue.filter("formatDateMonthMin", (value, formatString) => {
    // 年月日
    if (value && value != "null") {
        formatString = formatString || "MM-DD HH:mm";
        return moment(value).format(formatString);
    }
});
Vue.filter("formatDateDetails", (value, formatString) => {
    // 年月日
    if (value && value != "null") {
        formatString = formatString || "YYYY-MM-DD HH:mm:ss";
        return moment(value).format(formatString);
    }
});
Vue.filter("formatDateDetailsyear", (value, formatString) => {
    // 年
    if (value && value != "null") {
        formatString = formatString || "YYYY";
        return moment(value).format(formatString);
    }
});
Vue.filter("formatDateday", (value, formatString) => {
    // 月日
    if (value && value != "null") {
        formatString = formatString || "MM-DD";
        return moment(value).format(formatString);
    }
    return "";
});
Vue.filter("yeartext", (value, formatString) => {
    // 月日
    if (value == "1") {
        return "更早";
    }
    return value;
});
// 文章状态
Vue.filter("customercolumn", value => {
    if (value && value != "null") {
        if (value == "0") {
            return "上架";
        } else if (value == "1") {
            return "下架";
        }
    }
});

Vue.filter("toMoney", num => {
    if (num === "null" || num === null || num === "" || num === undefined) {
        return "————";
    }
    num = parseFloat(num).toFixed(2);
    num = Number(num.split(".")[0]).toLocaleString() + "." + num.split(".")[1];
    return num; //返回的是字符串23,245.12保留2位小数
});

//根据key转换value，无匹配项返回原Key值
//value: ''
//options: [{key: '',value:'',...},
//			{key: '',value:'',...},...]
Vue.filter("key2value", (value, options = []) => {
    let res = "未知";
    if (value == null) {
        return res;
    }
    options.forEach((item = {}) => {
        if (item.key == value) {
            res = item.value;
        }
    });
    return res;
});

//秒数转换时分秒
Vue.filter("formatSeconds", value => {
    if (value === null || value === "") {
        return "00:00:00";
    }
    var secondTime = parseInt(value), // 秒
        minuteTime = 0, // 分
        hourTime = 0; // 小时

    if (secondTime > 60) {
        //如果秒数大于60，将秒数转换成整数
        //获取分钟，除以60取整数，得到整数分钟
        minuteTime = parseInt(secondTime / 60);

        //获取秒数，秒数取佘，得到整数秒数
        secondTime = parseInt(secondTime % 60);

        //如果分钟大于60，将分钟转换成小时
        if (minuteTime > 60) {
            //获取小时，获取分钟除以60，得到整数小时
            hourTime = parseInt(minuteTime / 60);
            //获取小时后取佘的分，获取分钟除以60取佘的分
            minuteTime = parseInt(minuteTime % 60);
        }
    }
    if (minuteTime < 10) {
        minuteTime = "0" + minuteTime;
    }
    if (hourTime < 10) {
        hourTime = "0" + hourTime;
    }
    if (secondTime < 10) {
        secondTime = "0" + secondTime;
    }
    var result = hourTime + ":" + minuteTime + ":" + secondTime;
    return result;
});

//小数转换百分比
Vue.filter("formatPercentage", value => {
    if (value && value != "null") {
        let formatPercentage = value * 100 + "%";
        return formatPercentage;
    }
});
Vue.filter("wordnumber", value => {
    if (value.length > 50) {
        return value.substring(0, 50);
    }
    return value;
});
// 客户级别
Vue.filter("customerRank", value => {
    if (value && value != "null") {
        if (value == "0") {
            return "普通用户";
        } else if (value == "1") {
            return "电商客户";
        } else if (value == "2") {
            return "月结客户";
        } else if (value == "3") {
            return "VIP客户";
        } else if (value == "4") {
            return "项目客户";
        }
    }
});

Vue.filter("activityState", value => {
    if (value && value != "null") {
        if (value == "0") {
            return "未开始";
        } else if (value == "1") {
            return "进行中";
        } else if (value == "2") {
            return "已结束";
        }
    }
});

Vue.filter("timestate", (statetime, endtime) => {
    // 年月日
    var date = new Date();
    var nowDate = date.toLocaleDateString();
    var time1 = new Date(nowDate).getTime();
    var time2 = new Date(endtime).getTime();
    var time3 = new Date(statetime).getTime();
    if (time2 !== "null") {
        if (time1 > time2 && time1 != time2) {
            return "已结束";
        } else if (time1 < time3) {
            return "未开始";
        }
        return "进行中";
    }
});

Vue.filter("textstate", data => {
    // 年月日
    // if (data !== "null" && data !== "undefined" && data !== "") {
    if (data == "0") {
        return "";
    } else if (data == "1") {
        return "";
    }
    return data;

    // }
});
